module.exports = __webpack_public_path__ + "img/第二層標題icon.e11b6809.svg";